// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentWrapper":"app-pages-song--contentWrapper"};